// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gZEhwnQAfx2q6zBpBNhhDQ
// Component: 1rItofzuaain
import * as React from "react";
import {
  Stack as Stack__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  renderPlasmicSlot
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import DashboardNotPaidStatusCard from "../../DashboardNotPaidStatusCard"; // plasmic-import: Y6peQNiaS2bm/component
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_collect_wise_draft.module.css"; // plasmic-import: gZEhwnQAfx2q6zBpBNhhDQ/projectcss
import sty from "./PlasmicDashboardPaymentsCard.module.css"; // plasmic-import: 1rItofzuaain/css

createPlasmicElementProxy;

export const PlasmicDashboardPaymentsCard__VariantProps = new Array();

export const PlasmicDashboardPaymentsCard__ArgProps = new Array(
  "amount",
  "client",
  "date"
);

const $$ = {};

function PlasmicDashboardPaymentsCard__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  return (
    <Stack__
      as={"div"}
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      hasGap={true}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        sty.root
      )}
    >
      <div className={classNames(projectcss.all, sty.freeBox__lq2DO)}>
        {renderPlasmicSlot({
          defaultContents: "$1040.00",
          value: args.amount,
          className: classNames(sty.slotTargetAmount)
        })}
      </div>
      <div className={classNames(projectcss.all, sty.freeBox__zzQnI)}>
        {renderPlasmicSlot({
          defaultContents: "McDonalds",
          value: args.client,
          className: classNames(sty.slotTargetClient)
        })}
      </div>
      <div
        data-plasmic-name={"statusStack"}
        data-plasmic-override={overrides.statusStack}
        className={classNames(projectcss.all, sty.statusStack)}
      >
        <DashboardNotPaidStatusCard
          data-plasmic-name={"dashboardNotPaidStatusCard"}
          data-plasmic-override={overrides.dashboardNotPaidStatusCard}
          className={classNames(
            "__wab_instance",
            sty.dashboardNotPaidStatusCard
          )}
        />
      </div>
      <div className={classNames(projectcss.all, sty.freeBox__zllRg)}>
        {renderPlasmicSlot({
          defaultContents: "Dec 28th",
          value: args.date,
          className: classNames(sty.slotTargetDate)
        })}
      </div>
    </Stack__>
  );
}

const PlasmicDescendants = {
  root: ["root", "statusStack", "dashboardNotPaidStatusCard"],
  statusStack: ["statusStack", "dashboardNotPaidStatusCard"],
  dashboardNotPaidStatusCard: ["dashboardNotPaidStatusCard"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicDashboardPaymentsCard__ArgProps,
          internalVariantPropNames: PlasmicDashboardPaymentsCard__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicDashboardPaymentsCard__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicDashboardPaymentsCard";
  } else {
    func.displayName = `PlasmicDashboardPaymentsCard.${nodeName}`;
  }
  return func;
}

export const PlasmicDashboardPaymentsCard = Object.assign(
  // Top-level PlasmicDashboardPaymentsCard renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    statusStack: makeNodeComponent("statusStack"),
    dashboardNotPaidStatusCard: makeNodeComponent("dashboardNotPaidStatusCard"),
    // Metadata about props expected for PlasmicDashboardPaymentsCard
    internalVariantProps: PlasmicDashboardPaymentsCard__VariantProps,
    internalArgProps: PlasmicDashboardPaymentsCard__ArgProps
  }
);

export default PlasmicDashboardPaymentsCard;
/* prettier-ignore-end */
